import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "name", "tableName" ]

  generate() {
    const nameValue = this.nameTarget.value;
    const tableNameValue = nameValue.replace(/\s+/g, '_').replace(/[^a-zA-Z0-9_]/g, '').toLowerCase();
    this.tableNameTarget.value = tableNameValue;
  }
}
